<template>
	<div id="app">
		<div class="mobileMenu" :class="{ 'slideOut': show }">
			<!-- Menu with UL and Social Links -->
			<div id="closeBtnContainer" @click="show = false">
				<div class="closeBtn"></div>
			</div>
			<div class="mainMenu">
				<div class="listMenu">
					<ul>
						<router-link to="/">
							<li 
							@click="show = false" 
							:class="{ 'activeLink': $route.path == '/' }"
							>Home</li>
						</router-link>

						<router-link to="/ideaology">
							<li 
							@click="show = false" 
							:class="{ 'activeLink': $route.path == '/ideaology' }"
							>Ideaology</li>
						</router-link>

						<router-link to="/ourStory">
							<li
							@click="show = false"
							:class="{ 'activeLink': $route.path == '/ourStory' }"
							>Story</li>
						</router-link>

						<router-link to="/reservations">
							<li 
							@click="show = false" 
							:class="{ 'activeLink': $route.path == '/reservations' }"
							>Reservations</li>
						</router-link>

						<router-link to="/contactUs">
							<li 
							@click="show = false" 
							:class="{ 'activeLink': $route.path == '/contactUs' }"
							>Contact Us</li>
						</router-link>
					</ul>
					<a
						class="location"
						href="https://goo.gl/maps/ZhJJewSts7yLyWk29"
						target="_blank"
					>13.7376° N, 100.5422° E</a>
					<div class="socialLinks">
						<a href="https://www.instagram.com/gaggan_anand/" target="_blank">
							<img src="./assets/instagram.svg" alt />
						</a>
						<a href="https://www.facebook.com/pages/Gaggan/396887507090222" target="_blank">
							<img src="./assets/facebook.svg" alt />
						</a>
						<a href="https://twitter.com/chefgagananand?lang=en" target="_blank">
							<img src="./assets/twitter.svg" alt />
						</a>
					</div>
				</div>
			</div>
		</div>

		<nav
			:class="[
      { 'navbarHidden': !showNavBar },
      { 'transparentNav': $route.path == '/' },
      { 'whiteNav': $route.path == '/ideaology' }
      ]"
		>
			<div class="wrapper">
				<router-link to="/" id="logo">
					<svg
						id="gagganWhite"
						xmlns="http://www.w3.org/2000/svg"
						width="104.223"
						height="50"
						viewBox="0 0 104.223 50"
					>
						<path
							id="Shape"
							d="M20.976,6.786V4.178S17.173.615,12.913.854,4.373,2.048,1.526,9.633,2,27.41,4.851,30.5A9.665,9.665,0,0,0,16.935,33.1c7.585-4.021,6.39-17.539,4.021-18.255H13.371l-.956.956s4.021,0,5.216.956,2.608,5.455,1.413,9.715a6.9,6.9,0,0,1-6.629,5.455c-2.13,0-6.39-1.413-7.824-9.476S3.875,8.7,6.961,5.393,15.282,1.093,20.976,6.786Z"
							transform="translate(-0.439 -0.842)"
							fill="#fff"
						/>
						<path
							id="Shape-2"
							data-name="Shape"
							d="M134.054,59.954a61.4,61.4,0,0,0-.717-6.39,6.124,6.124,0,0,0-2.13-3.325c-1.891-1.652-5.693-.239-6.39.717l1.194,1.891s1.413-2.608,3.086-.956c.956.956.717.478,1.194,2.13a9.9,9.9,0,0,1,.478,2.369s-6.669-.239-8.1,7.127c-1.413,7.346,2.847,9.476,4.977,9.715a6.871,6.871,0,0,0,3.563-.478l4.738.717S134.293,68.952,134.054,59.954Zm-2.369,8.54a12.45,12.45,0,0,1-.239,1.891s-2.847,2.847-4.738-3.325c-1.652-5.932,1.413-8.54,3.8-8.3C130.491,58.759,132.163,61.128,131.685,68.494Z"
							transform="translate(-98.11 -39.796)"
							fill="#fff"
						/>
						<path
							id="Shape-3"
							data-name="Shape"
							d="M389.015,59.954a61.374,61.374,0,0,0-.717-6.39,6.125,6.125,0,0,0-2.13-3.325c-1.891-1.652-5.693-.239-6.39.717l1.194,1.891s1.413-2.608,3.086-.956c.956.956.717.478,1.195,2.13a9.9,9.9,0,0,1,.478,2.369s-6.629-.239-8.062,7.107c-1.413,7.346,2.847,9.476,4.977,9.715a6.871,6.871,0,0,0,3.563-.478l4.738.717C390.906,73.471,389.253,68.952,389.015,59.954Zm-2.369,8.54a12.453,12.453,0,0,1-.239,1.891s-2.847,2.847-4.738-3.325c-1.652-5.932,1.413-8.54,3.8-8.3C385.451,58.759,387.123,61.128,386.645,68.494Z"
							transform="translate(-302.346 -39.796)"
							fill="#fff"
						/>
						<path
							id="Shape-4"
							data-name="Shape"
							d="M213.181,48.175s-4.738-2.847-9.476,4.5c-4.5,8.3-.478,15.647,1.194,16.822,1.652,1.194,4.738,3.325,8.062,1.413,0,0,0,9-1.891,12.084s-3.086,4.021-6.629,4.977c0,0,8.3.239,10.67-7.824,0,0,1.194-3.325,1.194-13.278,0-8.54.239-19.669.239-19.669Zm-.239,19.908s-4.26,3.563-6.171-2.369-.478-11.845.717-13.278c1.194-1.413,2.369-3.325,5.455-1.652C212.942,50.783,213.659,65,212.942,68.083Z"
							transform="translate(-161.59 -37.971)"
							fill="#fff"
						/>
						<path
							id="Shape-5"
							data-name="Shape"
							d="M300.081,48.175s-4.738-2.847-9.476,4.5c-4.5,8.3-.478,15.647,1.194,16.822,1.652,1.194,4.738,3.325,8.062,1.413,0,0,0,9-1.891,12.084s-3.086,4.021-6.629,4.977c0,0,8.3.239,10.67-7.824,0,0,1.194-3.325,1.194-13.278,0-8.54.239-19.669.239-19.669Zm-.239,19.908s-4.26,3.563-6.171-2.369-.478-11.845.717-13.278c1.194-1.413,2.369-3.325,5.455-1.652C299.842,50.783,300.559,65,299.842,68.083Z"
							transform="translate(-231.19 -37.971)"
							fill="#fff"
						/>
						<path
							id="Shape-6"
							data-name="Shape"
							d="M458.4,74.4a154.866,154.866,0,0,0,0-22.993l4.5.956s1.413-1.652,4.977-.956c4.021,1.194,3.563,4.5,3.563,6.868V74.642h-3.563s.717-14.931,0-18.016c-.239-2.369-.956-2.608-2.608-3.325s-2.847,1.891-2.847,2.369-.956,12.323-.478,18.972Z"
							transform="translate(-367.232 -41.206)"
							fill="#fff"
						/>
					</svg>
				</router-link>

				<ul class="desktopShow">
					<router-link to="/">
						<li>Home</li>
					</router-link>

					<router-link to="/ideaology">
						<li>Ideaology</li>
					</router-link>

					<router-link to="/ourStory">
						<li>Our Story</li>
					</router-link>

					<router-link to="/reservations">
						<li>Reservations</li>
					</router-link>

					<router-link to="/contactUs">
						<li>Contact Us</li>
					</router-link>
				</ul>

				<div id="menuBtn" class="mobileShow" @click="show = true" :class="{ 'hide' : show }">
					<p>menu</p>
				</div>
			</div>
		</nav>

		<transition name="fade" mode="out-in">
			<router-view class="routerView" :class="{ 'slideView': show }" />
		</transition>
	</div>
</template>


<script>
export default {
	data() {
		return {
			show: false,
			showNavBar: true,
			lastScrollPosition: 0
		};
	},
	mounted() {
		window.addEventListener("scroll", this.onScroll);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.onScroll);
	},
	methods: {
		onScroll() {
			const currentScrollPosition =
				window.pageYOffset || document.documentElement.scrollTop;
			if (currentScrollPosition < 0) {
				return;
			}
			// Stop executing this function if the difference between
			// current scroll position and last scroll position is less than some offset

			if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
				return;
			}
			this.showNavBar = currentScrollPosition < this.lastScrollPosition;
			this.lastScrollPosition = currentScrollPosition;
		}
	}
};
</script>

<style lang="scss" src="./styles/main.scss">
</style>
